import React from "react";
import styled from "styled-components";
import {Spin} from "antd";
import {HomeOutlined, InfoCircleOutlined} from "@ant-design/icons";
import {
    PopupContainer,
    Header,
    TitleContainer,
    Icon,
    Title,
    Section,
    List,
    ListItem
} from "components/customer/customerHomePageWithShiftScore/style/CourierPopup.style";

const PopupTitleLink = styled.a`
    color: inherit;

    &:hover {
        color: #1890ff;
    }
`;

// Kartın sağ üstündeki kapatma butonunun altına girmemesi için sağda boşluk bırakılıyor
const DetailLink = styled.a`
    margin-left: auto;
    margin-right: 24px;
    display: flex;
    align-items: center;
    color: #8c8c8c;
    font-size: 16px;

    &:hover {
        color: #1890ff;
    }
`;

export const MapSubCompanyPopup = ({subCompany, detail, detailLoading}) => {
    const subCompanyId = subCompany?._id;

    return (
        <PopupContainer>
            <Header>
                <TitleContainer>
                    <Icon>
                        <HomeOutlined />
                    </Icon>
                    <Title>
                        {subCompanyId ? (
                            <PopupTitleLink
                                href={`/companies/sub-company/${subCompanyId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {subCompany?.name}
                            </PopupTitleLink>
                        ) : (
                            subCompany?.name
                        )}
                    </Title>
                    {subCompanyId ? (
                        <DetailLink
                            href={`/companies/sub-company/${subCompanyId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Alt Firma Detayı"
                        >
                            <InfoCircleOutlined />
                        </DetailLink>
                    ) : null}
                </TitleContainer>
            </Header>
            <Section>
                <List>
                    <ListItem>Alt Firma: {subCompany?.name}</ListItem>
                    {subCompany?.companyName ? (
                        <ListItem>Firma: {subCompany.companyName}</ListItem>
                    ) : null}
                    <ListItem>
                        Telefon:{" "}
                        {detailLoading ? <Spin size="small" /> : detail?.authorizedPhone || "-"}
                    </ListItem>
                </List>
            </Section>
        </PopupContainer>
    );
};
